import { render } from "./Menstruation.vue?vue&type=template&id=22acc176&ts=true"
import script from "./Menstruation.vue?vue&type=script&lang=ts"
export * from "./Menstruation.vue?vue&type=script&lang=ts"

import "./Menstruation.vue?vue&type=style&index=0&id=22acc176&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__